module.exports = __webpack_public_path__ + "img/fulltime-ffffff.e06f3395.svg";